import React from "react";

/**
 * Light white-label badge shown on public pages of orgs run by a reseller
 * auction-company partner. Renders nothing when there's no partner.
 */
export const PartnerPoweredBadge = ({ partner, className = "" }) => {
    if (!partner || !partner.brand_name) return null;
    return (
        <div className={`flex items-center justify-center gap-2.5 py-4 ${className}`} data-testid="partner-powered-badge">
            {partner.logo_url && (
                <img src={partner.logo_url} alt={partner.brand_name}
                     className="h-7 w-7 object-contain rounded" />
            )}
            <span className="text-xs text-foreground/55">
                Presented by <strong className="text-foreground/75">{partner.brand_name}</strong>
            </span>
        </div>
    );
};

export default PartnerPoweredBadge;
